import { UPDATE_OBJECT, SET_VISIBILITY, VisibilityFilters } from "../constants/action-types";

const initialState = {
  whyPad: {
    "id":"",
    newCustomer: {
      "other": "",
      "flatApartment": "",
      "bungalow": "",
      "houseTerrace": "",
      "houseSemi": "",
      "houseDetached": "",
      "whyMoving": "",
      "whenMove": "",
      "financingMove": "",
      "adviser": "",
      "existingCustomer": 0,
      "beds": "",
      "priceFrom" : "",
      "priceTo": "",
      "gdprConsent": ""
    }
 },
 checkArray: ['houseDetached', 'houseSemi', 'houseTerrace', 'bungalow', 'flatApartment', 'other', 'adviser', 'gdprConsent'],
 stageVisibility: VisibilityFilters.SHOW_STAGE1
};

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case SET_VISIBILITY:
      return Object.assign({}, state, {
        stageVisibility: action.filter
      })
    case UPDATE_OBJECT:
      return {
        ...state,
        whyPad: action.payload
      }
    default:
      return state
  }
    

  // if (action.type === UPDATE_OBJECT) {
  //   console.log(action.payload);
  //   return {
  //     ...state,
  //     whyPad: action.payload
  //   }
  // }
  // return state;
}

export default rootReducer;